import { apiFetch } from './http';

export function getAgents() {
  return apiFetch('/api/agents');
}

export function getAgent(id) {
  return apiFetch(`/api/agents/${id}`);
}

export function getAgentTasks(id) {
  return apiFetch(`/api/agents/${id}/tasks`);
}

export function getAgentMemory(id) {
  // Stats ride along with facts so the Memory tab needs one request.
  return apiFetch(`/api/agents/${id}/memory`).then((memory) => ({
    facts: memory.facts || memory,
    stats: memory.stats || null
  }));
}

export function getAgentConfig(id) {
  return apiFetch(`/api/agents/${id}/config`);
}

export function getAgentPerformance(id) {
  return apiFetch(`/api/agents/${id}/performance`);
}
